import { useEffect, useState } from 'react'

/**
 * Laufende Uhr: tickt im Sekundentakt und liefert die aktuelle lokale Zeit. Das Intervall wird beim
 * Unmount sauber abgeräumt (kein Leak, keine Updates auf einer entfernten Komponente). Bewusst KEIN
 * Polling-Drift-Ausgleich — für eine Anzeige-Uhr genügt der 1s-Tick.
 */
export function useLiveClock(): Date {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000)
    return () => clearInterval(id)
  }, [])
  return now
}
